import { createSelector } from "reselect";
import get from "lodash/fp/get";

export const config = state => state.config;
export const user = state => state.user;

export const loggedIn = createSelector(user, get("loggedIn"));



// WEBPACK FOOTER //
// ./src/redux/selectors/index.js